import { Position } from '../core/GridGeometry.js';

/**
 * Interface for games that support Vortex gate functionality.
 * Implemented by all 12 Vortex game classes.
 */
export interface IVortexGame {
    setVortexData(gatePairs: Array<[Position, Position]>, allGates: Set<string>): void;
    isGateCell(pos: Position): boolean;
    isActiveGate(pos: Position): boolean;
    canActivateGate(pos: Position): boolean;
    toggleVortexGate(pos: Position): boolean;
    getActiveGatePairs(): Map<string, string>;
    getVortexGatePairs(): Array<[Position, Position]>;
    getAllGatePositions(): Set<string>;
}

/**
 * Type guard to check if a game object supports Vortex gates.
 */
export function isVortexGame(game: unknown): game is IVortexGame {
    return (
        game !== null &&
        typeof game === 'object' &&
        typeof (game as IVortexGame).setVortexData === 'function' &&
        typeof (game as IVortexGame).toggleVortexGate === 'function'
    );
}

/**
 * Interface for renderers and inputs that support gate mode toggling.
 */
export interface IGateModeReceiver {
    setGateMode(enabled: boolean): void;
}

/**
 * Type guard to check if a renderer or input supports gate mode.
 */
export function isGateModeReceiver(obj: unknown): obj is IGateModeReceiver {
    return (
        obj !== null &&
        typeof obj === 'object' &&
        typeof (obj as IGateModeReceiver).setGateMode === 'function'
    );
}
